import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/owlBranding/studyBuddy.webp'

export const StudyBuddy: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'time'} />
)
